import { Pipe, PipeTransform } from '@angular/core';
import { PathInfoResultEnum, PathResultCrate, StartTargetResultEnum } from '@cue/navigation-services';

@Pipe({
  name: 'isRouteNotFound',
  standalone: true,
})
export class IsRouteNotFoundPipe implements PipeTransform {
  transform(routeResult: PathResultCrate): boolean {
    if (routeResult) {
      return (
        routeResult.path === PathInfoResultEnum.PathNotFound &&
        routeResult.start === StartTargetResultEnum.Found &&
        routeResult.target === StartTargetResultEnum.Found
      );
    } else {
      return true;
    }
  }
}
